import { MenuToggler } from "./app/menu.js"

import "./app/slider.js"
import "./app/infoModal.js"

require("./app/video");


document.addEventListener("DOMContentLoaded", function () {
	new MenuToggler("#primary-menu", ["#primary-menu-toggle", "#primary-menu-toggle-bg"], ["#open-mobile-menu", "#close-mobile-menu"], "menu-open")
})
